var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdvSwiperBanner',{class:_vm.$style['adv-banner'],attrs:{"adv-id":_vm.AdvIdEnum.LOAN_APPLY_RESULT_TXXY_BANNER},on:{"init":_vm.onInit,"indicator-change":_vm.indicatorChange,"click-item":_vm.clickItem}})}
var staticRenderFns = []

export { render, staticRenderFns }